module.exports = __webpack_public_path__ + "img/40_69_003_670.7b2c3f49.jpg";